define('form',['jquery', 'lib/utils', 'form-validation', 'pickerdate', 'select2', 'tooltipster', 'numeral', 'picker', 'wickedpicker'],
    function($, utils, FormValidation, select2, tooltipster, wickedpicker) {

        'use strict';

        var Form = function($form) {

            this.$form = $form;
        };


        Form.prototype.init = function() {

            var _this = this,
                $textareas = this.$form.find('[ data-textarea ]'),
                $datepickersFuture = this.$form.find('[ data-el="datepicker-future" ]'),
                $datepickersPast = this.$form.find('[ data-el="datepicker-past" ]'),
                $datepickersBinded = this.$form.find('.form-field__input--datepicker-binded'),
                $datepickers = this.$form.find('[ data-el="datepicker" ]'),
                $monthpickers = this.$form.find('[ data-el="monthpicker" ]'),
                $monthpickersGeneral = this.$form.find('[ data-el="monthpicker-general" ]'),
                $months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                $shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                $datepickersWffm = this.$form.find('[data-el="datepicker-wffm" ]'),
                $dp,
                dpOptions,
                dpMax,
                dpLabelId,
                $uploaders = $('[ data-uploader-field ]'),
                $previewRemovers = this.$form.find('[ data-uploader-remove ]'),
                $checkboxToggles = this.$form.find('[ data-checkbox-toggle ]'),
                $selectToggle = this.$form.find('[data-select-toggle]'),
                $legendToggleTarget = this.$form.find('[data-toggle-target]'),
                $termsCheckbox = this.$form.find('[ data-checkbox-terms ]'),
                $formDataTablePost = this.$form.find('[data-table-post]'),
                $formDataTable = this.$form.find('[data-table-form]'),
                $fakecbox2 = $('.form-field--fakecbox2_input'),
                $collapsable = $('.fieldset--collapsable'),
                $checkboxToggle = $('.form-field__input--checkbox--toggle'),
                $select_Toggle = $('.form-field__input--select--toggle'),
                $radioToggle = $('.form-field__radio--toggle'),
                $ratingstar = $('.form-field--ratingstar'),
                $inputBinding = $('.form-field__input--text-binded'),
                $tooltip = $('.form-field__label--tooltip'),
                $tooltip2 = $('.form-dynamic-tooltip'),
                $otp = $('.form-field__input--otp'),
                $hasLimits = $('[data-cbox-max]'),
                $password = $('.form-field__input--password'),
                $passShowHide = $('.form-field__label-password-visibility'),
                $numFields = $('.form-field__input--text[type=number]').not('.numInitialized'),
                defaultOpts = {
                    closeOnSelect: true,
                    format: 'dd mmmm yyyy',
                    formatSubmit: 'dd mmmm yyyy',
                    onStart: function() {
                        // set default date
                        var $dp = this.$node,
                            date;

                        if ($dp.data('initial-date')) {
                            date = new Date($dp.data('initial-date'));
                            this.set('select', [date.getFullYear(), date.getMonth(), date.getDate()]);
                        }
                    },
                    onOpen: function() {
                        _this.scrollIntoView(this.$node);
                    },
                    onClose: function() {
                        this.component.$node.parsley().validate();
                    }
                };

            // arabic translations
            if (utils.isRTL()) {
                defaultOpts.monthsFull = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
                $shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                defaultOpts.monthsShort = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                defaultOpts.weekdaysShort = ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
                defaultOpts.today = 'اليوم';
                defaultOpts.clear = 'مسح';
                defaultOpts.close = 'مغلق';
                defaultOpts.labelMonthNext = 'الشهر القادم';
                defaultOpts.labelMonthPrev = 'الشهر السابق';
                defaultOpts.labelMonthSelect = 'اختر الشهر';
                defaultOpts.labelYearSelect = 'اختر السنة';
                defaultOpts.format = 'dd mmmm yyyy';
                defaultOpts.formatSubmit = 'dd mmm yyyy';
            };

            // $numFields.each(function() {
            //     var _this = this,
            //         $input = $(this);

            //     $input.after(`<span class="form-field__number--controls">
            //                         <button class="form-field__number inc" type="button"><span class="aria-only">+</span></button>
            //                         <button class="form-field__number dec" type="button"><span class="aria-only">-</span></button>
            //                     <span`);

            //     $input.closest('.form-field').find('.form-field__number.inc').off('click.nf').on('click.nf', function() {
            //         $input[0].stepUp();
            //     });

            //     $input.closest('.form-field').find('.form-field__number.dec').off('click.nf').on('click.nf', function() {
            //         $input[0].stepDown();
            //     });

            //     $input.addClass('numInitialized')
            // });

            /////////////////////
            ///START DRAG&DROP///
            /////////////////////

            $('[data-dropupload]').each(function() {
                var $dropzone = $(this);

                $dropzone.off('drop.file').on('drop.file', function(event) {
                    dragupload($dropzone, event);
                });

                $dropzone.find('.form-field__input--upload').off('change.file').on('change.file', function(event) {
                    dragupload($dropzone, event);
                });

                $dropzone.off('dragover.file').on('dragover.file', function(event) {
                    event.preventDefault();

                    $(this).addClass('drag');
                });

                $dropzone.off('dragleave.file').on('dragleave.file', function(event) {
                    event.preventDefault();

                    $(this).removeClass('drag');
                });
            });

            var dragupload = function(uploader, event) {
                var $this = $(uploader),
                    $input = $(uploader).find('input'),
                    $fcont = $(uploader).closest('.form-field').find('.form-field--upload_dzfiles'),
                    // $fcont = $('[data-uploader-filecontainer="' + $input.attr('id') + '"]'),
                    types = JSON.parse('[' + $input.attr('data-accepts').toLowerCase() + ']'),
                    isMutiple = $input.prop('multiple'),
                    maxSize = parseInt($input.attr('data-size')),
                    previewPath = $input.attr('data-preview'),
                    word = ['doc', 'docx'],
                    excel = ['xls', 'xlsx'],
                    pdf = ['pdf'],
                    img = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp', 'bmp'],
                    uploadicons = JSON.parse($input.attr('data-upload-icons')),
                    maxfilecount = ($input.attr('data-max-file') != undefined && $input.attr('data-max-file') != '') ? parseInt($input.attr('data-max-file')) : 99999,
                    fileError = 0,
                    fileSize = 0,
                    inputID = '',
                    fileList,
                    sizeError = false,
                    willRender = $this.hasClass('display-attachment-none') ? false : true,
                    countError = false;

                event.preventDefault();

                if ($input.data('fileList') == undefined) {
                    fileList = [];
                } else {
                    fileList = $input.data('fileList');
                }

                //console.log(previewPath)
                if (event.originalEvent != undefined) {
                    if (event.originalEvent.dataTransfer != undefined) {
                        for (var i = 0; i < event.originalEvent.dataTransfer.items.length; i++) {
                            if (event.originalEvent.dataTransfer.items[i].kind === 'file') {
                                var file = event.originalEvent.dataTransfer.items[i].getAsFile(),
                                    ext = file.name.replace(/^.*\./, '').toLowerCase(),
                                    extimg;

                                if (types.indexOf(ext) != -1) {
                                    if (file.size > maxSize) {
                                        sizeError = true
                                    }
                                } else {
                                    fileError++;
                                };
                            };
                        };

                        if (!isMutiple) {
                            countError = event.originalEvent.dataTransfer.items.length > 1;
                        } else {
                            countError = event.originalEvent.dataTransfer.items.length > (maxfilecount - $fcont.find('.form-field--upload--details').length);
                        };

                        // sizeError = fileSize > maxSize;

                        $this.closest('.form-field--upload').find('[data-uploader-format-error]').hide();
                        $this.closest('.form-field--upload').find('[data-uploader-size-error]').hide();
                        $this.closest('.form-field--upload').find('[data-uploader-count-error]').hide();

                        if (fileError == 0 && !countError && !sizeError && !$input.prop('disabled')) {
                            $input[0].files = event.originalEvent.dataTransfer.files;

                            //$fcont.html('')

                            //$fcont.append('<div class="button--upload_remove" data-dropupload-remove="true"></div>')

                            for (var j = 0; j < event.originalEvent.dataTransfer.items.length; j++) {
                                if (event.originalEvent.dataTransfer.items[j].kind === 'file') {
                                    var file = event.originalEvent.dataTransfer.items[j].getAsFile(),
                                        fileID = utils.uniqueID(),
                                        ext1 = file.name.split('.').pop();

                                    file.id = fileID;
                                    fileList.push(file);

                                    if (word.indexOf(ext1) != -1) {
                                        extimg = uploadicons.word
                                    } else if (pdf.indexOf(ext1) != -1) {
                                        extimg = uploadicons.pdf
                                    } else if (excel.indexOf(ext1) != -1) {
                                        extimg = uploadicons.excel
                                    } else if (img.indexOf(ext1) != -1) {
                                        extimg = uploadicons.img
                                    } else {
                                        extimg = uploadicons.misc
                                    }

                                    if (willRender) {
                                        $fcont.append('<div class="form-field--upload--details" data-uploader-item-id="' + $input.attr('id') + '"><div style="display: flex;align-items:center"><div class="form-field__input--upload-filetype" data-uploader-filetype="' + $input.attr('id') + '" style="display: flex;"><img src="' + extimg + '"></div><div><p class="form-field__input--upload-filename" data-uploader-filename="' + $input.attr('id') + '" style="">' + file.name + '</p><div class="form-field__input--upload-filesize hidden" data-uploader-filesize="' + $input.attr('id') + '" style="display: block;"><span data-totalsize="' + $input.attr('id') + '">' + numeral(file.size / 1000).format('00.') + '</span>kB</div></div></div><button class="button--upload_remove hidden" data-dropupload-remove="' + $input.attr('id') + '" style="display: inline-block;"><span class="aria-only">Remove</span></button><div class="form-field__input--upload-filesize_barouter"><div class="form-field__input--upload-filesize_bar"><div class="form-field__input--upload-filesize_green"></div></div><div class="form-field__input--upload-filesize_rate"><span>0</span>%</div></div></div>');

                                        $fcont.find('.form-field__input--upload-filesize').not('.uploaded').each(function() {
                                            var tick = (parseInt($(this).attr('data-uploader-size')) / 1000) / 75,
                                                $filesize = $(this),
                                                $filesizeRate = $filesize.closest('.form-field--upload--details').find('.form-field__input--upload-filesize_rate span'),
                                                $rate = 0;

                                            $(this).fadeIn();

                                            setTimeout(function() {
                                                $filesize.closest('.form-field--upload--details').find('.form-field__input--upload-filesize_green').css('width', '100%');

                                                var interval = setInterval(function() {
                                                    if ($rate <= 100) {
                                                        $filesizeRate.text($rate);
                                                        $rate++;
                                                    } else {
                                                        clearInterval(interval);
                                                    }
                                                }, 20);
                                            }, 400);
                                            setTimeout(function() {
                                                $filesize.closest('.form-field--upload--details').find('.form-field__input--upload-filesize_barouter').fadeOut();
                                            }, 2400)
                                            $(this).addClass('uploaded');
                                        });
                                    }
                                }
                            }
                            $input.trigger('change');
                            $input.trigger('focusout');
                            $input.trigger('uploadchange');
                            //$input.data('fileList', fileList);
                        } else {
                            if (fileError != 0) {
                                //console.log('file type error');
                                $this.closest('.form-field--upload').find('[data-uploader-format-error]').show();
                            }
                            if (sizeError) {
                                //console.log('file size error');
                                $this.closest('.form-field--upload').find('[data-uploader-size-error]').show();
                            }
                            if (countError) {
                                //console.log('file count error');
                                $this.closest('.form-field--upload').find('[data-uploader-count-error]').show();
                            }
                        };
                        if (sizeError) {
                            //console.log('file size error');
                            $this.closest('.form-field--upload').find('[data-uploader-size-error]').show();
                        }
                    } else {
                        for (var i = 0; i < $input[0].files.length; i++) {
                            //if (event.originalEvent.dataTransfer.items[i].kind === 'file') {
                            var file = $input[0].files[i],
                                ext = file.name.replace(/^.*\./, '').toLowerCase();

                            if (types.indexOf(ext) != -1) {
                                if (file.size > maxSize) {
                                    sizeError = true
                                }
                            } else {
                                fileError++;
                            };
                            //};
                        };

                        if (!isMutiple) {
                            countError = $input[0].files.length > 1;
                        } else {
                            countError = $input[0].files.length > (maxfilecount - $fcont.find('.form-field--upload--details').length);
                        };

                        // sizeError = fileSize > maxSize;

                        $this.closest('.form-field--upload').find('[data-uploader-format-error]').hide();
                        $this.closest('.form-field--upload').find('[data-uploader-size-error]').hide();
                        $this.closest('.form-field--upload').find('[data-uploader-count-error]').hide();

                        //console.log(fileError == 0 && !sizeError && !countError)

                        if (fileError == 0 && !countError && !sizeError && !$input.prop('disabled')) {
                            //$input[0].files = event.originalEvent.dataTransfer.files;

                            if (!isMutiple) {
                                $fcont.html('')
                            }

                            //$fcont.append('<div class="button--upload_remove" data-dropupload-remove="true"></div>')

                            for (var j = 0; j < $input[0].files.length; j++) {
                                //if ($input[0].files[j].kind === 'file') {
                                var file = $input[0].files[j],
                                    ext1 = file.name.split('.').pop();

                                if (word.indexOf(ext1) != -1) {
                                    extimg = uploadicons.word
                                } else if (pdf.indexOf(ext1) != -1) {
                                    extimg = uploadicons.pdf
                                } else if (excel.indexOf(ext1) != -1) {
                                    extimg = uploadicons.excel
                                } else if (img.indexOf(ext1) != -1) {
                                    extimg = uploadicons.img
                                } else {
                                    extimg = uploadicons.misc
                                }

                                if (willRender) {
                                    $fcont.append('<div class="form-field--upload--details" data-uploader-item-id="' + $input.attr('id') + '"><div style="display: flex;align-items:center"><div class="form-field__input--upload-filetype" data-uploader-filetype="' + $input.attr('id') + '" style="display: flex;"><img src="' + extimg + '"></div><div><p class="form-field__input--upload-filename" data-uploader-filename="' + $input.attr('id') + '" style="">' + file.name + '</p><div class="form-field__input--upload-filesize hidden" data-uploader-filesize="' + $input.attr('id') + '" style="display: block;"><span data-totalsize="' + $input.attr('id') + '">' + numeral(file.size / 1000).format('00.') + '</span>kB</div></div></div><button class="button--upload_remove hidden" data-dropupload-remove="' + $input.attr('id') + '" style="display: inline-block;"><span class="aria-only">Remove</span></button><div class="form-field__input--upload-filesize_bar"><div class="form-field__input--upload-filesize_green"></div></div></div>');

                                    $fcont.find('.form-field__input--upload-filesize').not('.uploaded').each(function() {
                                        var tick = (parseInt($(this).attr('data-uploader-size')) / 1000) / 75,
                                            $filesize = $(this),
                                            $filesizeRate = $filesize.closest('.form-field--upload--details').find('.form-field__input--upload-filesize_rate span'),
                                            $rate = 0;

                                        $(this).fadeIn();

                                        setTimeout(function() {
                                            $filesize.closest('.form-field--upload--details').find('.form-field__input--upload-filesize_green').css('width', '100%');

                                            var interval = setInterval(function() {
                                                if ($rate <= 100) {
                                                    $filesizeRate.text($rate);
                                                    $rate++;
                                                } else {
                                                    clearInterval(interval);
                                                }
                                            }, 20);
                                        }, 400);
                                        setTimeout(function() {
                                            $filesize.closest('.form-field--upload--details').find('.form-field__input--upload-filesize_barouter').fadeOut();
                                        }, 2400)
                                        $(this).addClass('uploaded');
                                    });
                                }

                                // $fcont.find('.form-field__input--upload-filesize').each(function() {
                                //     var tick = (parseInt($(this).attr('data-uploader-size')) / 1000) / 75,
                                //         $filesize = $(this),
                                //         $rate = 0;

                                //     $(this).fadeIn();
                                //     $(this).find('.form-field__input--upload-filesize_green').css('width', '100%');
                                //     setTimeout(function() {
                                //         $filesize.find('.form-field__input--upload-filesize_barouter').fadeOut();
                                //     }, 2000)
                                // });
                                //}
                            }
                            $input.trigger('uploadchange');
                            $input.trigger('focusout');
                        } else {
                            if (fileError != 0) {
                                //console.log('file type error');
                                $this.closest('.form-field--upload').find('[data-uploader-format-error]').show();
                            }
                            if (sizeError) {
                                //console.log('file size error');
                                $this.closest('.form-field--upload').find('[data-uploader-size-error]').show();
                            }
                            if (countError) {
                                //console.log('file count error');
                                $this.closest('.form-field--upload').find('[data-uploader-count-error]').show();
                            }
                        };
                        if (sizeError) {
                            //console.log('file size error');
                            $this.closest('.form-field--upload').find('[data-uploader-size-error]').show();
                        }
                    };
                    $(uploader).removeClass('drag');
                };

                //console.log($('[data-dropupload-remove="' + $input.attr('id') + '"]'))

                $('[data-dropupload-remove="' + $input.attr('id') + '"]').off('click.drag').on('click.drag', function(event) {
                    event.preventDefault();
                    var removeID = $(this).attr('data-dropupload-remove');

                    if (!$(this).closest('.form-field--upload_dzfiles').hasClass('nodelete')) {

                        $(this).closest('.form-field--upload--details[data-uploader-item-id="' + removeID + '"]').remove();

                    };

                    fileList = fileList.filter(function(file) {

                        //console.log(file.id + ': ' + removeID)

                        return file.id !== removeID;
                    });
                    //console.log(fileList)
                    $input.data('fileList', fileList);
                });
            };

            ///////////////////
            ///END DRAG&DROP///
            ///////////////////


            //for checkbox keyboard
            $('.form-field__input--checkbox').on('keypress', function(event) {
                if (event.keyCode == 13) {
                    $(this).click()
                }
            })

            //for dynamic form
            if (_this.$form.hasClass('form-dynamic')) {
                var $sections = _this.$form.find('.form-dynamic-section');

                $sections.each(function() {
                    var $inputs = $(this).find('input'),
                        $thisSection = $(this);

                    $inputs.each(function() {
                        $(this).off('change.dynamic, focusout.dynamic').on('change.dynamic, focusout.dynamic', function() {
                            var errors = 0,
                                incomplete = 0;

                            setTimeout(function() {
                                $inputs.each(function() {
                                    if (!$(this).parsley().isValid() && $(this).closest('.form-field').css('display') != 'none') {
                                        errors++;
                                    };
                                });

                                if (errors == 0 && $thisSection.hasClass('current')) {
                                    $thisSection.removeClass('current');
                                    $thisSection.next('.form-dynamic-section').addClass('active');
                                    $thisSection.next('.form-dynamic-section').addClass('current');
                                };

                                $sections.each(function() {
                                    if (!$(this).hasClass('active')) {
                                        incomplete++;
                                    };
                                });

                                if (incomplete == 0) {
                                    _this.$form.find('button.button.disabled').attr('disabled', false);
                                    _this.$form.find('button.button.disabled').removeClass('disabled');
                                };
                            }, 100);
                        })
                    })
                });
            };

            $monthpickersGeneral.each(function () {
                $(this).datepicker({
                    view: 'months',
                    minView: 'months',
                    dateFormat: 'MM yyyy',
                    autoClose: true,
                    language: utils.isRTL() ? 'ar' : 'en',       // Automatically close the picker after selection
                    onSelect: function (formattedDate, date) {
                        $(this).val(formattedDate); // Update the input field with the selected month
                    }
                })
            })

            //for cbox limiting
            $hasLimits.each(function() {
                var $parent = $(this),
                    limit = parseInt($(this).attr('data-cbox-max')),
                    $cboxs = $(this).find('.form-field__input--checkbox');

                $cboxs.each(function() {
                    $(this).off('click.limit').on('click.limit', function(event) {
                        if (!($parent.find('.form-field__input--checkbox:checked').length <= limit) && $(this).prop('checked')) {
                            event.preventDefault();
                        };
                    });
                })
            });

            //for tooltip
            $tooltip.each(function() {
                if (!$(this).hasClass('tooltipstered')) {
                    var text = $(this).attr('tooltip-text');

                    $(this).tooltipster({
                        content: text,
                        maxWidth: 250,
                        arrow: false,
                        contentAsHTML: true
                    });
                };
            });

            //for tooltip
            $tooltip2.each(function() {
                if (!$(this).hasClass('tooltipstered')) {
                    var text = $(this).attr('tooltip-text');

                    $(this).tooltipster({
                        content: text,
                        maxWidth: 250,
                        arrow: false,
                        contentAsHTML: true
                    });
                };
            });

            //for new fakecbox
            $fakecbox2.each(function() {
                $(this).off('click.fbox').on('click.fbox', function() {
                    var $input = $(this).find('input[type="checkbox"]');

                    $(this).toggleClass('form-field--fakecbox2_input--active');
                    $input.prop("checked", !($input.prop("checked")));
                })
            });

            //for collapsable fields
            setTimeout(function() {
                $collapsable.each(function() {
                    var $field = $(this),
                        $height = 0;

                    $field.children().each(function() {
                        if ($(this).css('display') != 'none') {
                            $height = $height + $(this).outerHeight(true);
                        }
                    });

                    if ($field.hasClass('fieldset--collapsable-closed')) {
                        $field.height($field.find('.legend').outerHeight(true));
                    } else {
                        $field.height($height);
                    };

                    $field.find('.legend').off('click.fcollapse').on('click.fcollapse', function() {
                        $height = 0;
                        $field.children().each(function() {
                            if ($(this).css('display') != 'none') {
                                $height = $height + $(this).outerHeight(true);
                            }
                        });
                        $field.toggleClass('fieldset--collapsable-closed');
                        if ($field.hasClass('fieldset--collapsable-closed')) {
                            $field.height($(this).outerHeight(true));
                        } else {
                            $field.height($height);
                        };
                    });
                });
            }, 500);

            $collapsable.each(function() {
                $(this).off('DOMSubtreeModified').on('DOMSubtreeModified', function() {
                    var $height = 0;
                    $(this).children().each(function() {
                        if ($(this).css('display') != 'none') {
                            $height = $height + $(this).outerHeight(true);
                        }
                    });
                    $(this).height($height);
                });
            });

            //for star rating
            $ratingstar.each(function() {
                var $parent = $(this),
                    $star = $(this).find('.form-field--ratingstar_icon'),
                    $input = $parent.find('.form-field__input--ratingstar');

                if (parseInt($input.val()) != NaN && parseInt($input.val()) != undefined) {
                    for (var i = 0; i < parseInt($input.val()); i++) {
                        if ($($star[i]).hasClass('active')) {
                            $($star[i]).removeClass('active');
                            $star.each(function() {
                                $($star[i]).removeClass('active');
                            });
                        } else {
                            $($star[i]).addClass('active');
                            $($star[i]).prevAll('.form-field--ratingstar_icon').addClass('active');
                        };
                    }
                }

                $star.each(function() {
                    $(this).off('mouseenter.form').on('mouseenter.form', function() {
                        $(this).prevAll('.form-field--ratingstar_icon').addClass('hover');
                    });
                    $(this).off('mouseout.form').on('mouseout.form', function() {
                        $(this).prevAll('.form-field--ratingstar_icon').removeClass('hover');
                    });
                    $(this).off('click.form').on('click.form', function() {
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            $star.each(function() {
                                $(this).removeClass('active');
                            });
                        } else {
                            $(this).addClass('active');
                            $(this).prevAll('.form-field--ratingstar_icon').addClass('active');
                        };
                        $parent.find('.form-field__input--ratingstar').val($parent.find('.form-field--ratingstar_icon.active').length);
                        $parent.find('.form-field__input--ratingstar').trigger('focusout');
                        //console.log($parent.find('.form-field__input--ratingstar').val());
                    });
                });
            });

            //for checkbox toggle
            setTimeout(function() {
                $checkboxToggle.each(function() {
                    var target = $(this).attr('toggle-target'),
                        clear = $(this).attr('is-clear');

                    if ($(this).prop('checked')) {
                        $(target).show()
                    } else {
                        $(target).hide()
                    };
                    $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');

                    $(this).off('click.ctoggle').on('click.ctoggle', function() {
                        if ($(this).prop('checked')) {
                            $(target).show()
                        } else {
                            $(target).hide()
                            if (clear == "true") {
                                $(target).find('.form-field__input--radio').prop('checked', false);
                                $(target).find('.form-field__input--checkbox').prop('checked', false);
                                $(target).find('.form-field__input--text').val('');
                            };
                        };
                        $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');
                    });
                });
            }, 250);

            //for radio toggle
            setTimeout(function() {
                $radioToggle.each(function() {
                    $(this).find('.form-field__input--radio').each(function() {
                        var target = $(this).attr('toggle-target'),
                            clear = $(this).attr('is-clear');

                        if ($(this).prop('checked')) {
                            $(target).show()
                        } else {
                            $(target).hide();
                            if (clear == "true") {
                                $(target).find('.form-field__input--radio').prop('checked', false);
                                $(target).find('.form-field__input--checkbox').prop('checked', false);
                                //$(target).find('input').val('');
                            };
                        };

                        $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');

                        $(this).off('click.rtoggle').on('click.rtoggle', function() {
                            $radioToggle.each(function() {
                                $(this).find('.form-field__input--radio').each(function() {
                                    var target = $(this).attr('toggle-target'),
                                        clear2 = $(this).attr('is-clear');

                                    if ($(this).prop('checked')) {
                                        $(target).show()
                                    } else {
                                        $(target).hide()
                                        if (clear2 == "true") {
                                            $(target).find('.form-field__input--radio').prop('checked', false);
                                            $(target).find('.form-field__input--checkbox').prop('checked', false);
                                            $(target).find('.form-field__input--text').val('');
                                        };
                                    };
                                });
                            });
                            $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');
                        });
                    });
                });
            }, 250);

            //for select toggle
            setTimeout(function() {
                $select_Toggle.each(function() {

                    $(this).find('option').each(function() {
                        var target = $(this).attr('toggle-target');

                        if ($(this).prop('selected')) {
                            $(target).show()
                        } else {
                            $(target).hide()
                        };
                    });

                    $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');

                    $(this).off('change.stoggle').on('change.stoggle', function() {
                        $(this).find('option').each(function() {
                            var target = $(this).attr('toggle-target');

                            if ($(this).prop('selected')) {
                                $(target).show()
                            } else {
                                $(target).hide()
                            };
                        });
                        $(this).closest('.fieldset--collapsable').trigger('DOMSubtreeModified');
                    });
                });
            }, 250);

            //for input binding
            $inputBinding.each(function() {
                var $binding_target = $(this).attr('binding-target');

                function binding_activate(elem, isKeyup) {

                    if (!isKeyup) {
                        if ($(elem).hasClass('form-field__input--select')) {
                            $($binding_target).html($(elem).find('option:selected').text());
                        } else {
                            if ($(elem).val().length == 0) {
                                $($binding_target).html($($binding_target).attr('binding-default'))
                            } else {
                                $($binding_target).html($(elem).val());
                            };
                        }
                    } else {
                        if ($(elem).val().length == 0) {
                            $($binding_target).html($($binding_target).attr('binding-default'))
                        } else {
                            $($binding_target).html($(elem).val());
                        }
                    };

                }

                $(this).off('change.binding').on('change.binding', function() {
                    binding_activate(this, false);
                });
                $(this).off('keyup.binding').on('keyup.binding', function() {
                    binding_activate(this, true);
                });

                if ($(this).hasClass('form-field__input--select')) {
                    $(this).trigger('change');
                }
            });

            //for OTP

            $otp.each(function() {
                var $i = $(this);

                $i.off('keyup.otp').on('keyup.otp', function() {
                    if (event.keyCode != 8) {
                        if ($i.val().length > 0) {
                            $i.focusout();
                            $i.closest('.form-field__input-wrapper_otp').next().find('.form-field__input--otp').focus();
                        };
                    } else {
                        $i.focusout();
                        $i.closest('.form-field__input-wrapper_otp').prev().find('.form-field__input--otp').focus();
                    };
                });
            });

            $otp.on('keyup blur', function() {
                var OTPValue = '';

                $.each($otp, function() {
                    OTPValue += $(this).val();
                });

                var otpMain = $(this).closest('.form-field--otp').find('.form-field__input--otp_main')
                otpMain.val(OTPValue);
            });


            $otp.on("paste", function() {
                var $this = $(this),
                    originalValue = $this.val(),
                    intRegex = /^\d+$/;

                $this.val("");

                $this.one("input.fromPaste", function() {
                    var $currentInputBox = $(this),
                        $currentParent = $currentInputBox.closest('.form-field--otp');

                    var pastedValue = $currentInputBox.val();

                    if (intRegex.test(pastedValue)) {
                        var values = pastedValue.split("");

                        $(values).each(function(index) {
                            var $inputBox = $currentParent.find('.form-field__input--otp[name="chars[' + (index + 1) + ']"]');
                            $inputBox.val(values[index])
                        });
                    } else {
                        $this.val(originalValue);
                    }
                });
            });

            //for Password


            $password.on('keyup blur paste', function() {
                var passwordValue = $(this).val();

                var conditionListItem = $(this).closest('.form-field--password').find('.form-field__messages-password-list');

                validatePassword(conditionListItem, passwordValue)

            });


            function validatePassword(list, val) {
                list.find('.form-field__messages-password-list-item').removeClass('valid');

                if (val.length >= 8) {
                    list.find('.message-minimum').addClass('valid');
                }
                if (val.search(/[a-z]/g) >= 0) {
                    list.find('.message-lowercase').addClass('valid');
                }
                if (val.search(/[A-Z]/g) >= 0) {
                    list.find('.message-uppercase').addClass('valid');
                }
                if (val.search(/[0-9]/g) >= 0) {
                    list.find('.message-number').addClass('valid');
                }
                if (val.search(/[!@#$%^&*]/g) >= 0) {
                    list.find('.message-special').addClass('valid');
                }
            }

            $passShowHide.off().on('click', function(e) {

                $(this).toggleClass('button--show button--hide');
                var thisInput = $(this).closest('.form-field--password').find('.form-field__input--password'),
                    visibile = $(this).hasClass('button--show') ? true : false;

                if (visibile) {
                    thisInput.attr('type', 'password')
                } else {
                    thisInput.attr('type', 'text')
                }

                e.preventDefault();

            });

            this.$form.find('.form-field__passwordtoggle').off('click.pw').on('click.pw', function() {
                var $input = $(this).closest('.form-field__input-passwordwrapper').find('.form-field__input');

                $(this).toggleClass('show');

                if ($(this).hasClass('show')) {
                    $input.attr('type', 'text');
                } else {
                    $input.attr('type', 'password');
                }
            });

            //for month pickers

            if (this.$form.parents('[ data-wffm ]').length > 0) {

                // init wffm datepickers
                $datepickersWffm.each(function(i, el) {
                    $dp = $(el).find('input');

                    if (true) {

                        dpLabelId = utils.uniqueID();
                        $dp.parents('.field-border').attr('id', dpLabelId);
                        dpLabelId = '#' + dpLabelId;

                        dpOptions = $dp.data('picker-options');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true, {
                                    container: dpLabelId
                                },
                                dpOptions,
                                defaultOpts
                            )
                        );
                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }

                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }

                    }

                });

            } else {

                // apply validation
                if (this.$form.attr('form-skipvalidation') != 'true') {
                    FormValidation.apply(this.$form);
                    FormValidation.limit();
                }


                // init textarea char count
                $textareas.each(function(i, el) {
                    _this.countTextChars(el);
                });

                $textareas.on('keyup', function() {
                    _this.countTextChars(this);
                });

                // init datepickers
                $datepickers.each(function(i, el) {
                    $dp = $(el);

                    if (true) {

                        dpOptions = $dp.data('picker-options');
                        dpLabelId = '#' + $dp.parents('.form-field').attr('id');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true,
                                dpOptions,
                                defaultOpts
                            )
                        );

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }

                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }

                    }

                });

                $datepickersFuture.each(function(i, el) {
                    $dp = $(el);

                    if (true) {

                        dpMax = $dp.data('date-max');
                        dpOptions = $dp.data('picker-options');
                        dpLabelId = '#' + $dp.parents('.form-field').attr('id');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        if (typeof dpMax === 'object') {
                            var maxDay = dpMax[0],
                                maxMonth = dpMax[1],
                                maxYear = dpMax[2],
                                day = new Date();

                            day.setDate(day.getDate() + maxDay);
                            day.setMonth(day.getMonth() + maxMonth);
                            day.setFullYear(day.getFullYear() + maxYear);

                            dpMax = {
                                max: day
                            };

                        } else if (typeof dpMax !== 'object') {
                            dpMax = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true, {
                                    container: dpLabelId,
                                    min: new Date()
                                },
                                dpOptions,
                                dpMax,
                                defaultOpts
                            )
                        );

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }


                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }
                    }

                });

                $datepickersPast.each(function(i, el) {
                    $dp = $(el);

                    if (true) {

                        dpOptions = $dp.data('picker-options');
                        dpLabelId = '#' + $dp.parents('.form-field').attr('id');

                        if (typeof dpOptions === 'string') {
                            dpOptions = JSON.parse(dpOptions);
                        } else if (typeof dpOptions !== 'object') {
                            dpOptions = {};
                        }

                        $dp.pickadate(
                            $.extend(
                                true, {
                                    container: dpLabelId,
                                    max: new Date()
                                },
                                dpOptions,
                                defaultOpts
                            )
                        );

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraints);
                        }


                        // IE9clicker (1of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
                        // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
                        $dp.after('<span data-clicker="' + dpLabelId + '" class="form-field__datepicker-icon-clicker"></span>');

                    } else {

                        $dp.attr('type', 'date');

                        // if dp is has a ref dataset update based on this
                        if ($dp.data('ref')) {
                            $dp.on('change', _this.setConstraintsMobile);
                        }
                    }

                });

                Date.prototype.addDays = function(days) {
                    var date = new Date(this.valueOf());

                    date.setDate(date.getDate() + days);

                    return date;
                };

                $datepickersBinded.each(function() {
                    var today = new Date(),
                        min = parseInt(jQuery(this).attr('data-el-to_min')),
                        max = jQuery(this).attr('data-el-to_max') != 'indefinite' ? parseInt(jQuery(this).attr('data-el-to_max')) : jQuery(this).attr('data-el-to_max');

                    var from_$input = jQuery(this).pickadate(),
                        from_picker = from_$input.pickadate('picker')

                    var to_$input = jQuery(jQuery(this).attr('data-el-to')).pickadate(),
                        to_picker = to_$input.pickadate('picker')


                    // Check if there’s a “from” or “to” date to start with.
                    if (typeof from_picker !== "undefined" && from_picker.get('value')) {
                        to_picker.set('min', from_picker.get('select').obj.addDays(min))
                    }

                    // When something is selected, update the “from” and “to” limits.
                    if (typeof from_picker !== "undefined") {
                        from_picker.on('set', function(event) {
                            if (event.select) {
                                if (typeof to_picker !== "undefined" && to_picker.get('select') !== null) {
                                    if (from_picker.get('select').obj > to_picker.get('select').obj.addDays(-min) || from_picker.get('select').obj < to_picker.get('select').obj.addDays(-max)) {
                                        to_picker.clear();
                                    };
                                }
                                to_picker.set('min', from_picker.get('select').obj.addDays(min));
                                if (max != 'indefinite') {
                                    to_picker.set('max', from_picker.get('select').obj.addDays(max));
                                }
                            } else if ('clear' in event) {
                                to_picker.set('min', today.addDays(min))
                                if (max != 'indefinite') {
                                    to_picker.set('max', today.addDays(max))
                                }
                            }
                        });
                    };
                    if (typeof to_picker !== "undefined") {
                        to_picker.on('set', function(event) {
                            if (event.select) {
                                //from_picker.set('max', to_picker.get('select').obj.addDays(15))
                                if (typeof from_picker !== "undefined" && from_picker.get('select') !== null) {
                                    if (to_picker.get('select').obj < from_picker.get('select').obj.addDays(min)) {
                                        from_picker.clear();
                                    };
                                }
                            } else if ('clear' in event) {
                                //from_picker.set('max', false)
                            }
                        });
                    }

                });

                // init upload image fields
                $uploaders.on('change', function(e) {
                    var size = $(this)[0].files[0].size;
                    var exeIndex = $(this)[0].files[0].name.indexOf('.exe');
                    // console.log($(this)[0].files[0].name.split('.').pop());
                    var extension = $(this).val().replace(/^.*\./, '').toLowerCase();
                    var contdd = $(this).closest('.form-field--upload');
                    var $j120 = $(this).closest('.j120-smart-response--button_wrapper');
                    var $j120errorFormat = $j120.find('.form-field__input--upload-format-error-message');
                    var $j120errorSize = $j120.find('.form-field__input--upload-size-error-message');
                    var errorFormat = contdd.find('.form-field__input--upload-format-error-message');
                    var errorSize = contdd.find('.form-field__input--upload-size-error-message');
                    var __this = $(this)

                    errorSize.hide()
                    errorFormat.hide()
                    $j120errorFormat.each(function() {
                        $(this).hide()
                    });
                    $j120errorSize.each(function() {
                        $(this).hide()
                    });

                    var formatList = $(this).data("accepts");

                    if (formatList) {
                        var formats = JSON.parse('[' + formatList.toLowerCase() + ']');
                    }
                    var thisSize = $(this).attr('data-size');




                    if (!formatList && !thisSize && (exeIndex == -1)) {
                        _this.previewUploadedImage(this);
                        //new upload//
                        if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                            var tick = (size / 1000) / 75,
                                $rate = 0;

                            __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeIn();
                            __this.closest('.form-field').find('[data-totalsize]').html(numeral(size / 1000).format('00.'));
                            __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '100%');
                            for (var i = 0; i < 75; i++) {
                                setTimeout(function() {
                                    __this.closest('.form-field').find('[data-currentsize]').html(numeral($rate + tick).format('00.'));
                                    $rate = $rate + tick;
                                }, (2000 / 75) * i);
                            };
                        };
                        //new upload end//

                    } else if ((!formatList && thisSize) || (formatList && !thisSize) || (formatList && thisSize)) {
                        if (exeIndex != -1) {
                            //console.log('error');
                            errorFormat.show();
                            $j120errorFormat.each(function() {
                                $(this).show()
                            });
                            //new upload//
                            if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                                __this.closest('.form-field').find('[data-currentsize]').html('0');
                                __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
                            };
                            //new upload end//
                            $(this).val("")
                        } else {

                            if (!formatList && thisSize) {

                                if (thisSize >= size) {
                                    _this.previewUploadedImage(this);
                                    //new upload//
                                    if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                        var tick = (size / 1000) / 75,
                                            $rate = 0;

                                        __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeIn();
                                        __this.closest('.form-field').find('[data-totalsize]').html(numeral(size / 1000).format('00.'));
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '100%');
                                        for (var i = 0; i < 75; i++) {
                                            setTimeout(function() {
                                                __this.closest('.form-field').find('[data-currentsize]').html(numeral($rate + tick).format('00.'));
                                                $rate = $rate + tick;
                                            }, (2000 / 75) * i);
                                        };
                                    };
                                    //new upload end//
                                } else {
                                    errorSize.show();
                                    $j120errorSize.each(function() {
                                        $(this).show()
                                    });
                                    //new upload//
                                    if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                                        __this.closest('.form-field').find('[data-currentsize]').html('0');
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
                                    };
                                    //new upload end//
                                    $(this).val("")
                                }
                            }
                            if (formatList && !thisSize) {

                                if (formats.indexOf(extension) > -1) {
                                    _this.previewUploadedImage(this);
                                    //new upload//
                                    if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                        var tick = (size / 1000) / 75,
                                            $rate = 0;

                                        __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeIn();
                                        __this.closest('.form-field').find('[data-totalsize]').html(numeral(size / 1000).format('00.'));
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '100%');
                                        for (var i = 0; i < 75; i++) {
                                            setTimeout(function() {
                                                __this.closest('.form-field').find('[data-currentsize]').html(numeral($rate + tick).format('00.'));
                                                $rate = $rate + tick;
                                            }, (2000 / 75) * i);
                                        };
                                    };
                                    //new upload end//
                                } else {
                                    errorFormat.show();
                                    $j120errorFormat.each(function() {
                                        $(this).show()
                                    });
                                    //new upload//
                                    if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                                        __this.closest('.form-field').find('[data-currentsize]').html('0');
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
                                    };
                                    //new upload end//
                                    $(this).val("")
                                }
                            }
                            if (formatList && thisSize) {

                                if (formats.indexOf(extension) > -1) {
                                    if (thisSize >= size) {
                                        _this.previewUploadedImage(this);
                                        //new upload//
                                        if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                            var tick = (size / 1000) / 75,
                                                $rate = 0;

                                            __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeIn();
                                            __this.closest('.form-field').find('[data-totalsize]').html(numeral(size / 1000).format('00.'));
                                            __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '100%');
                                            for (var i = 0; i < 75; i++) {
                                                setTimeout(function() {
                                                    __this.closest('.form-field').find('[data-currentsize]').html(numeral($rate + tick).format('00.'));
                                                    $rate = $rate + tick;
                                                }, (2000 / 75) * i);
                                            };
                                        };
                                        //new upload end//
                                    } else {
                                        errorSize.show();
                                        $j120errorSize.each(function() {
                                            $(this).show()
                                        });
                                        //new upload//
                                        if (__this.closest('.form-field').hasClass('form-field--upload_new')) {

                                            __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                                            __this.closest('.form-field').find('[data-currentsize]').html('0');
                                            __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
                                        };
                                        //new upload end//
                                        $(this).val("")
                                    }
                                } else {
                                    errorFormat.show();
                                    $j120errorFormat.each(function() {
                                        $(this).show()
                                    });
                                    //new upload//
                                    if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                                        __this.closest('.form-field').find('[data-currentsize]').html('0');
                                        __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
                                    };
                                    //new upload end//
                                    $(this).val("")
                                }
                            }
                        }


                    } else if (exeIndex != -1) {
                        //console.log('error');
                        errorFormat.show();
                        $j120errorFormat.each(function() {
                            $(this).show()
                        });
                        //new upload//
                        if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                            __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                            __this.closest('.form-field').find('[data-currentsize]').html('0');
                            __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
                        };
                        //new upload end//
                        $(this).val("")
                    } else {

                        _this.previewUploadedImage(this);
                        //new upload//
                        if (__this.closest('.form-field').hasClass('form-field--upload_new')) {
                            var tick = (size / 1000) / 75,
                                $rate = 0;

                            __this.closest('.form-field').find('.form-field__input--upload-filesize').fadeIn();
                            __this.closest('.form-field').find('[data-totalsize]').html(numeral(size / 1000).format('00.'));
                            __this.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '100%');
                            for (var i = 0; i < 75; i++) {
                                setTimeout(function() {
                                    __this.closest('.form-field').find('[data-currentsize]').html(numeral($rate + tick).format('00.'));
                                    $rate = $rate + tick;
                                }, (2000 / 75) * i);
                            };
                        };
                        //new upload end//
                    }




                    $(this).parsley().validate();
                });




                // show file if one is already selected, i.e. browser back
                $uploaders.each(function(i, el) {
                    var $el = $(el)[0];

                    if ($el.files && $el.files[0]) { _this.previewUploadedImage(el); }
                });

                // init remove preview upload image buttons
                $previewRemovers.on('click', function(e) {
                    e.preventDefault();
                    _this.removeUploadedImage(this);
                });

                // init checkbox toggles
                $checkboxToggles.on('click', function() {

                    _this.toggleFieldset($(this));

                });






                // init terms checkbox
                $.each($termsCheckbox, function() {
                    var $checkbox = $(this).find('input'),
                        $modalTrigger = $(this).find('a'),
                        $modalContent = $('[data-content=terms_checkbox]'),
                        $agreeButton = $modalContent.find('[data-modal-confirm]'),
                        $closeButton = $modalContent.find('[data-close]');

                    $modalTrigger.on('click', function(e) { e.preventDefault(); });

                    $agreeButton.on('click', function(e) {

                        e.preventDefault();

                        $checkbox.prop('checked', true);
                        $closeButton.trigger('click');


                    });

                });

            }

            // IE9clicker (2of2) - as IE9 doesn't have events on pseudoselectors (clicking on calendar icon does not trigger picker)
            // and as it would be too much work before delivery to update markup of all date fields... go js ugly solution
            $('[ data-clicker ]').on('click', function() {
                $(this).siblings('[ data-el="datepicker" ]').click();
            });

            $('.form-field__input--textarea').each(function () {
                var $textarea = $(this);

                if ($textarea.closest('.form-field').find('.form-field__messages .form-field__description').text().length > 110) {
                    $textarea.closest('.form-field').addClass('longdesc');
                };
            });


            this.initSelect2();
            $(window).off('form_reinit').on('form_reinit', function() {
                _this.init();
            })
        };

        Form.prototype.initSelect2 = function() {
            var _this = this;

            $('.form-field__input--select2').each(function() {
                var $parent = $(this).closest('.form-field'),
                    $placeholder = ($(this).attr('data-placeholder') == null || undefined) ? '' : $(this).attr('data-placeholder');

                $(this).select2({
                    width: '100%',
                    placeholder: $placeholder
                });
                $parent.find('.select2-selection__arrow').remove();
                $parent.find('.select2-selection').css('height', 'auto');
                if (($(this).hasClass('j120-location-form-field__input--select2') && !utils.isRTL()) || (!$(this).hasClass('j120-location-form-field__input--select2') && utils.isRTL())) {
                    // $parent.find('.select2-selection__rendered').css({ 'padding': '5px 12px 8px', 'padding-left': '44px' });
                } else if (($(this).hasClass('j120-location-form-field__input--select2') && utils.isRTL()) || (!$(this).hasClass('j120-location-form-field__input--select2') && !utils.isRTL())) {
                    // $parent.find('.select2-selection__rendered').css({ 'padding': '5px 12px 8px', 'padding-right': '44px' });
                }
            });
        };

        Form.prototype.setConstraints = function() {
            var $el = $(this),
                ref = $el.data('ref'),
                refDate = $el.pickadate('picker').get('select'),
                minPickers = $('[data-mindate="' + ref + '"]'),
                maxPickers = $('[data-maxdate="' + ref + '"]');

            refDate = refDate ? refDate.pick : false;

            // update min and max dates
            minPickers.each(function(i, picker) {
                var $picker = $(picker),
                    currentDate = $picker.pickadate('picker').get('select'),
                    minOffset = parseInt($picker.data('mindate-offset'), 10) * 86400000,
                    newMin = refDate ? refDate + minOffset : false,
                    updateObj = { 'min': new Date(newMin) };

                if (currentDate && newMin) {
                    updateObj.select = (currentDate && currentDate.pick < newMin) ? newMin : currentDate.pick;
                }

                $picker.pickadate('picker').set(updateObj);
            });

            maxPickers.each(function(i, picker) {
                var $picker = $(picker),
                    currentDate = $picker.pickadate('picker').get('select'),
                    maxOffset = parseInt($picker.data('maxdate-offset'), 10) * 86400000,
                    newMax = refDate ? refDate + maxOffset : false,
                    updateObj = { 'max': new Date(newMax) };

                if (currentDate && newMax) {
                    updateObj.select = (currentDate && currentDate.pick > newMax) ? newMax : currentDate.pick;
                }

                $picker.pickadate('picker').set(updateObj);
            });
        };

        Form.prototype.setConstraintsMobile = function() {
            var $el = $(this),
                ref = $el.data('ref'),
                refDate = $el.val(),
                minPickers = $('[data-mindate="' + ref + '"]'),
                maxPickers = $('[data-maxdate="' + ref + '"]');

            // update min and max dates
            minPickers.prop('min', refDate);
            maxPickers.prop('max', refDate);
        };


        Form.prototype.countTextChars = function(textarea) {

            var $textarea = $(textarea),
                $count = $('[ data-charcount="' + $textarea.data('textarea') + '" ]');

            $count.text($textarea.val().length);
        };


        Form.prototype.scrollIntoView = function($node) {

            $('html, body').animate({
                scrollTop: ~~$node.offset().top - 100
            }, 750);
        };


        Form.prototype.previewUploadedImage = function(input) {
            var $input = $(input),
                $container = $input.closest('.form-field--upload'),
                id = $input.data('uploader-field'),
                $remover = $container.find('[ data-uploader-remove="' + id + '" ]');

            if (input.files && input.files[0]) {

                var reader,
                    isImage = false,
                    filename = input.files[0].name,
                    filetype = input.files[0].name.split('.').pop(),
                    $details = $container.find('.form-field--upload_new-details'),
                    $previewer = $container.find('[ data-uploader-image="' + id + '" ]'),
                    $filetype = $container.find('[ data-uploader-filetype="' + id + '" ]'),
                    $filename = $container.find('[ data-uploader-filename="' + id + '" ]');


                if (window.FileReader && window.Blob && /image/i.test(input.files[0].type)) {

                    reader = new FileReader();

                    reader.onload = function(e) {
                        $previewer.attr('src', e.target.result);
                    };

                    reader.readAsDataURL(input.files[0]);

                    isImage = true;
                }

                if (isImage === false) { // not an image - use the 'success' placeholder image
                    $previewer.attr('src', $previewer.data('success'));
                }

                // console.log(input.val());
                $details.css('display', 'flex');
                $filename.text(filename).fadeIn();
                $filetype.text(filetype).fadeIn();
                $remover.fadeIn();
            } else {
                this.removeUploadedImage($remover[0]);
            }

        };


        Form.prototype.removeUploadedImage = function(button) {

            var $button = $(button),
                $container = $button.closest('.form-field--upload'),
                id = $button.data('uploader-remove'),
                $details = $container.find('.form-field--upload_new-details'),
                $previewer = $container.find('[ data-uploader-image="' + id + '" ]'),
                $uploader = $container.find('[ data-uploader-field="' + id + '" ]'),
                $filetype = $container.find('[ data-uploader-filetype="' + id + '" ]'),
                $filename = $container.find('[ data-uploader-filename="' + id + '" ]');

            //console.log($uploader.val())



            $previewer.attr('src', $previewer.data('src'));
            $uploader.val('').focus();
            if (/MSIE/.test(navigator.userAgent)) {
                $uploader.replaceWith($uploader = $uploader.clone(true));
            }
            $filename.text('').fadeOut();
            $filetype.text('').fadeOut();
            //console.log($uploader.val())
            $button.fadeOut();
            $details.fadeOut();

            //new upload//
            if ($filename = $container.closest('.form-field').hasClass('form-field--upload_new')) {

                $filename = $container.closest('.form-field').find('.form-field__input--upload-filesize').fadeOut();
                $filename = $container.closest('.form-field').find('[data-currentsize]').html('0');
                $filename = $container.closest('.form-field').find('.form-field__input--upload-filesize_green').css('width', '0%');
            };
            //new upload end//

        };

        Form.prototype.toggleFieldset = function($checkox) {

            var $fieldset = $('#' + $checkox.attr('aria-controls')),
                expanded = $fieldset.attr('aria-expanded') === 'true',
                pressed = $fieldset.attr('aria-pressed') === 'true',
                childrenFields = $fieldset.find('input[type=text], input[type=number], input[type=email]').not('[data-el=datepicker]');

            $checkox.attr('aria-pressed', pressed = !pressed);
            $fieldset.attr('aria-expanded', expanded = !expanded);
            $fieldset.toggleClass('fieldset--hidden');

            if (!$fieldset.hasClass('fieldset--hidden')) {
                // enable validation on child fields
                childrenFields.parsley({
                    excluded: 'input.form-field__input--readonly, input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden'
                });
            }
        };

        return Form;

    });

